import React from 'react'
import Manager from '../../public/components/Manager'
import ConsumableCategoryDiv from './ConsumableCategoryDiv'
Ext.require('Ext.Toast')


const config = {

    buttons: [
        {
            icon: 'plus', text: '添加...', handler: ({ showDetail, refreshPage }) =>
                Tyan.pubForm.showDialog('消耗品分类', props => <ConsumableCategoryDiv {...props} id={0} onSave={refreshPage} />)
        },
    ],
    columns: [
        { _text: '分类名称', field: 'Name', search: true, minWidth: 150, locked: false, flex: 1, },
        { _text: '管理员', field: 'Admin', search: true, minWidth: 150, flex: 2, },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) =>
        Tyan.pubForm.showDialog('消耗品分类', props => <ConsumableCategoryDiv {...props} id={data.id} onSave={refreshPage} />),
}

export default props => <Manager {...props} config={config} />